import { useKidStore } from '@stores/kid'

import { useActiveKidDisciplinesApi } from '@api/kids/active-kid-disciplines.hook'

export default defineNuxtRouteMiddleware(() => {
  const kidId = useKidStore().activeKidId
  if (kidId === null) return

  void useActiveKidDisciplinesApi(kidId)
})
